export enum UserGroup {
  SuperAdmins = 'Super-Admins',
  Admins = 'Admins',
  Advanced = 'Advanced',
  Editors = 'Editors',
  Readers = 'Readers',
  Custom = 'Custom',
}
